var map = {
	"./bash": 1558,
	"./java": 1559,
	"./json": 1560,
	"./julia": 1561,
	"./python": 1562,
	"./r": 1563,
	"./rust": 1564,
	"./scala": 1565,
	"./shell": 1566,
	"./sql": 1567,
	"./xml": 1568,
	"./yaml": 1569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1557;